import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from 'src/app/core/config/application-config.service';
import { Login } from '../signin/login.model';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  constructor(
    private http: HttpClient,
    private applicationConfigService: ApplicationConfigService
  ) {}

  changePassword(username: string, newPassword: string, token: string | null): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: token ? `Bearer ${token}` : ''
    });
    const login = new Login(username, newPassword, 'ROLE_EMPLOYEE', false);
    return this.http.post(
      this.applicationConfigService.getJpaMicroServiceEndpointFor('api/login/resetPassword'),
      login,
      { headers, responseType: 'text' as 'json' }
    );
  }
}